<div *ngIf="IsVisible" tabindex="0">
    <section-info [overrideTitle]="'validation.overrideTitle' | translate" [overrideDescription]="''">
    </section-info>
    <ul>
        <li *ngFor="let error of ValidationMessages; let i = index" class="validation-message" [trimRichtextAriaLabel]="error">
            <span [outerHTML]="error"></span>
        </li>
    </ul>
</div>